// Phase 1A Step 34 — Section 09 Final CTA.
// Verbatim port from handoff/landing-reference/sections.jsx FinalCTA.
// Ghosted background full-rollover number + closing "Your agents are ready" headline.

import { Link } from "react-router-dom";

interface FinalCTAProps {
  stake: number;
  weeks: number;
  odds: number;
  takeout: number;
  symbol: string;
}

export function FinalCTA({ stake, weeks, odds, takeout, symbol }: FinalCTAProps): JSX.Element {
  // Use full-rollover ceiling as the ghost number (more dramatic) — verbatim
  // port matches handoff: ghost = stake * odds^weeks.
  const ghostValue = stake * Math.pow(odds, weeks);
  // The original handoff also computes finalValue but does not render it directly.
  void takeout;

  return (
    <section
      className="sz-l-final-cta"
      style={{
        position: "relative",
        minHeight: "92vh",
        display: "flex",
        alignItems: "center",
        borderTop: "1px solid var(--border)",
        padding: "120px 0",
        overflow: "hidden",
      }}
    >
      <div className="kente-bg" />

      {/* Ghosted background number */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          whiteSpace: "nowrap",
          opacity: 0.06,
          pointerEvents: "none",
        }}
      >
        <div
          className="display num"
          style={{
            fontSize: "clamp(180px, 30vw, 460px)",
            color: "var(--accent)",
            lineHeight: 0.85,
          }}
        >
          {symbol}
          {Math.round(ghostValue).toLocaleString()}
        </div>
      </div>

      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <div style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
          <span
            className="eyebrow"
            style={{ display: "inline-flex", alignItems: "center", gap: 12 }}
          >
            <span className="live-dot" />
            Section 09 · Begin
          </span>
          <h2
            className="serif"
            style={{
              marginTop: 28,
              fontSize: "clamp(56px, 7vw, 110px)",
              fontWeight: 500,
              color: "var(--text)",
              lineHeight: 0.98,
              letterSpacing: "-0.015em",
            }}
          >
            Your agents
            <br />
            <em style={{ color: "var(--accent)", fontStyle: "italic" }}>are ready.</em>
          </h2>
          <p
            style={{
              marginTop: 28,
              fontSize: 17,
              color: "var(--text-muted)",
              lineHeight: 1.55,
              maxWidth: 560,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Seven days free. Full engine. No credit card. Walk away after one chain if it isn&apos;t
            for you — most don&apos;t.
          </p>
          <div
            style={{
              marginTop: 44,
              display: "flex",
              justifyContent: "center",
              gap: 14,
              flexWrap: "wrap",
            }}
          >
            <Link to="/auth" className="btn btn-primary">
              Start Free <span className="btn-arrow">→</span>
            </Link>
            <a href="#agents" className="btn btn-ghost">
              See How It Works
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
